export function locationsMap() {
    let locations = void (0);
    let popup = $("#location-popup");
    let popupPhoto = popup.find(".locations-popup-photo img");
    let popupAddress = popup.find("address p");
    let popupIntroText = popup.find(".intro-text");
    let popupLink = popup.find(".button");
    initMap();

    function initMap() {
        let pinWidth;
        let pinHeight;
        if (window.innerWidth >= 1200) {
            pinWidth = 70;
            pinHeight = 100;
        } else {
            pinWidth = 35;
            pinHeight = 50;
        }
        locations = mapData["locations"];
        let markers = [];
        let mapStyle = [
            {
                "featureType": "all",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "weight": "2.00"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#9c9c9c"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#7b7b7b"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#46bcec"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#c8d7d4"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#070707"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            }
        ];
        let map = new google.maps.Map(document.getElementById('big-map'), {
            styles: mapStyle,
            zoom: 12,
            scrollwheel: false,
            scaleControl: false,
            draggable: !(typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1),
            // zoomControl: false,
            // disableDoubleClickZoom: true,
            panControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            fullscreenControl: false,
            center: new google.maps.LatLng(locations[0].lat, locations[0].lng)
        });
        let bounds = new google.maps.LatLngBounds();
        let marker = void 0,
            i = void 0;

        for (i = 0; i < locations.length; i++) {
            let lat = locations[i].lat;
            let lng = locations[i].lng;
            let markerPin = locations[i].pin;
            let markerPinActive = locations[i].pinActive;
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: map,
                icon: {
                    url: markerPin,
                    size: new google.maps.Size(pinWidth, pinHeight),
                    scaledSize: new google.maps.Size(pinWidth, pinHeight),
                }
                // size: new google.maps.Size(36, 50),
                // scaledSize: new google.maps.Size(36, 50),
                // title: locations[i].state
            });
            markers.push(marker);
            bounds.extend(marker.position);
            marker.addListener('mouseover', function () {
                return function () {
                    this.setIcon(markerPinActive);
                }
            }(marker, i));

            marker.addListener('mouseout', function () {
                return function () {
                    this.setIcon(markerPin);
                }
            }(marker, i));


            google.maps.event.addListener(marker, 'click', function (marker, i) {
                return function () {
                    popupPhoto.attr("src", locations[i].photo);
                    popupAddress.text(locations[i].address);
                    popupIntroText.text(locations[i].text);
                    popupLink.attr("href", locations[i].link);
                    popup.addClass("show");
                    $("body").addClass("overflow");
                };
            }(marker, i));

            if (locations.length < 2) {
                map.setZoom(16);
            } else {
                map.fitBounds(bounds);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/locationsMap.js